import React from 'react';
import { Input } from '@avila-tek/ui/src';
import { Variant, Option } from '../../../models';

interface VariantOptionsProps {
  formState: Partial<Variant>;
  setFormState: React.Dispatch<React.SetStateAction<Partial<Variant>>>;
  options: Option[];
}

function VariantOptions({
  formState,
  setFormState,
  options,
}: VariantOptionsProps) {
  const { option } = formState;
  const { option1, option2, option3 } = option;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      option: {
        ...option,
        [name]: value,
      },
    });
  };

  const inputContainerClass = 'w-full md:w-1/2 lg:w-1/3 px-4';

  return (
    <div>
      <div className="flex justify-center text-center border-b py-1 text-gray-700 bg-gray-100">
        Variantes
      </div>
      <div className="flex flex-row flex-wrap w-full px-2 py-3 border-b">
        <div className={inputContainerClass}>
          <Input
            required
            label={options[0]?.name ?? 'Variante 1'}
            name="option1"
            placeholder="Ingrese una variante"
            type="text"
            value={option1}
            onChange={handleInputChange}
          />
        </div>
        {options?.length >= 2 ? (
          <div className={inputContainerClass}>
            <Input
              required
              label={options[1]?.name ?? 'Variante 2'}
              name="option2"
              placeholder="Ingrese una variante"
              type="text"
              disabled={options?.length < 2}
              value={option2}
              onChange={handleInputChange}
            />
          </div>
        ) : null}
        {options?.length >= 3 ? (
          <div className={inputContainerClass}>
            <Input
              required
              label={options[2]?.name ?? 'Variante 3'}
              name="option3"
              placeholder="Ingrese una variante"
              type="text"
              disabled={options?.length < 3}
              value={option3}
              onChange={handleInputChange}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default VariantOptions;
